import React, { Component } from 'react';
import ReactGA from 'react-ga';
import './Style';

class NotProducedComponent extends Component {
    constructor() {
        super();
    }

    componentDidMount() {
        // ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div className="not-found-component">
                <div className="error-message-container">
                    <h1>Error</h1>
                    <h2>This order has not yet been Produced</h2>
                </div>
            </div>
        );
    }
}

export default NotProducedComponent;
